import { EColors } from 'libs/styles/styling';
import { CSSProperties } from 'react';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    style?: CSSProperties;
    cursor?: 'pointer' | 'default' | 'nwse-resize' | 'nesw-resize';
    onMouseUp?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    onMouseDown?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const Corner = (props: Props): JSX.Element => {
    return (
        <div
            style={props.style}
            className={props.className}
            onMouseDown={props.onMouseDown}
            onMouseUp={props.onMouseUp}
        >
            <S_Square $width={14} $cursor={props.cursor} />
        </div>
    );
};

const S_Square = styled.div<{ $cursor: Props['cursor']; $width: number }>`
    height: ${(props) => props.$width}px;
    width: ${(props) => props.$width}px;
    background: ${EColors.SELECT};
    position: absolute;
    left: -${(props) => props.$width / 2}px;
    top: -${(props) => props.$width / 2}px;
    z-index: 1;
    ${(props) => {
        switch (props.$cursor) {
            case 'pointer':
                return css`
                    cursor: pointer;
                `;
            case 'nwse-resize':
                return css`
                    cursor: nwse-resize;
                `;
            case 'nesw-resize':
                return css`
                    cursor: nesw-resize;
                `;
            default:
                return css`
                    cursor: default;
                `;
        }
    }}
    &:hover {
        height: ${(props) => props.$width + 4}px;
        width: ${(props) => props.$width + 4}px;
        left: -${(props) => (props.$width + 4) / 2}px;
        top: -${(props) => (props.$width + 4) / 2}px;
    }
`;
